<template>
  <div class="casef">
    <div class="casePhone">
      <Float></Float>
      <div class="casePhoneCases">
        <span>Customer Cases</span>
      </div>
      <div class="casePhoneCasesP">
        <p>Palmcube has become the preferred choice for numerous international leading <br>
          hotel management groups and renowned brands.Our digital hotel management <br> solutions effectivelv assist these
          hotels in
          their operations
        </p>
        <p class="casePhoneCasesJoin"> Join us now and experience increased profitability for your hotel as well.</p>
      </div>

       <div class="casePhoneCasesImg">
        <img src="../assets/case333.jpg" alt="">
       </div>

      <div class="aboutPhoneUs">
        <div>
          <img src="../assets/Palm Cube-Logo-06.png" alt="">
          <p class="Contact1">Contact US </p>
          <p>+234 9064837926 <br>lockettqin@palm-cube.com</p>
          <p class="Contact2">SHANGHAI </p>
          <p>Lumous intelligent Technology (shanghai)Co,Ltd</p>
          <p class="Contact2">LAGOS </p>
          <p>Address: ATG House, 2A, Isaac John Street,<br>GRA Ikeja, Lagos, Nigeria.</p>
        </div>
        <div class="aboutPhoneUsright">
          <div>
            <input v-model="fullName" type="text" class="input" style="width: 300px; height: 30px;" placeholder="Name(*)">
          </div>
          <div>
            <input v-model="mobile" type="text" class="input" style="width: 300px; height: 30px;" placeholder="Mobile(*)">
          </div>
          <div>
            <input v-model="email" type="text" class="input" style="width: 300px; height: 30px; " placeholder="Email(*)">
          </div>
          <div>
            <textarea type="text" v-model="message" class="input" style="width: 300px; height: 80px; "
              placeholder="Leave your message..." />
          </div>
          <div>
            <button class="sand" @click="addClick" style="width: 80px;height: 30px;">Send</button>
          </div>


        </div>
      </div>
    </div>
    <div class="case">
      <div class="casePcS">

        <div class="casePcSl">
          <span>Customer Cases</span>
          <p>Palmcube has become the preferred choice for numer- <br> ous international leading hotel management groups
            and <br> renowned brands.Our digital hotel management solu- <br> tions effectivelv assist these hotels in
            their operations
          </p>
          <p class="join"> Join us now and experience increased profitability for <br> your hotel as well.</p>
        </div>
        <div class="casePcSr">
          <img src="../assets/case333.jpg" alt="">
        </div>
      </div>
      <!-- <div class="caseImg">
        <div class="caseImgtext">
          <span>Customer Cases</span>
        </div>
      </div>
      <div class="rujia">
        <div class="rujial">
          <img src="../assets/case2.png" alt="">
        </div>
        <div class="rujiar">
          <img src="../assets/case3.png" alt="">
          <p>In June 2020, BTG Home Inns Group (6000+ running <br>
            hotels), the first Chinese hotel group listed overseas, <br>
            initiated a deep cooperation with us to create a better <br>
            intelligent service experience. And we have over 800 <br>
            partner hotels till 2023</p>
        </div>

      </div>
      <div class="rujia">
        <div class="rujial">
          <img src="../assets/case4.png" alt="">
        </div>
        <div class="rujiar">
          <img src="../assets/case5.png" alt="">
          <p>Atour Hotel（NASDAQ: ATAT）established in 2013, fo- <br> cuses on
            providing unique and personalized experi- <br> ences for its guests. It offers
            a range of accommodation <br> options, including hotels, apartments, and
            vacation <br> rentals with more than 600 hotels in service. <br>
            In 2021, Atour Group started using Palmhotel, and cur- <br> rently, there are
            50+ stores online. In 2022, Atour Group <br> has included our product in
            the essential checklist for <br> opening stores within the group.</p>
        </div>


      </div>
      <div class="rujia">
        <div class="rujial">
          <img src="../assets/case6.png" alt="">
        </div>
        <div class="rujiar">
          <img src="../assets/case7.png" alt="">
          <p>Hampton by Hilton is a hotel brand owned by Hilton <br> Worldwide
            Holdings Inc. It is known for providing com- <br> fortable accommodations
            and a friendly, welcoming at- <br> mosphere to travelers around the
            world. In June 2021, <br> Hampton officially introduced our product to
            assist em- <br> ployees in more efficient business processing. The <br> system
            helped to improve the business processing effi- <br> ciency of the hotel
            front desk by approximately 40%</p>
        </div>


      </div> -->

      <div class="aboutD">
        <div class="aboutD-z">
          <div class="left">
            <img src="../assets/Palm Cube-Logo-06.png" alt="">
            <span class="us">Contact US</span>
            <p>+234 9064837926</p>
            <p>lockettqin@palm-cube.com</p>

            <span>SHANGHAI</span>
            <p>Lumous intelligent Technology <br>(shanghia)Co,Ltd</p>

            <span class="lagos">LAGOS</span>
            <p>Address: ATG House, 2A, Isaac John Street,<br>GRA Ikeja, Lagos, Nigeria.</p>
          </div>
          <div class="right">
            <div>
              <input v-model="fullName" type="text" class="input" style="width: 600px; height: 40px;"
                placeholder="Name(*)">
            </div>
            <div>
              <input v-model="mobile" type="text" class="input" style="width: 600px; height: 40px;"
                placeholder="Mobile(*)">
            </div>
            <div>
              <input v-model="email" type="text" class="input" style="width: 600px; height: 40px; "
                placeholder="Email(*)">
            </div>
            <div>
              <textarea type="text" v-model="message" class="input" style="width: 600px; height: 120px; "
                placeholder="Leave your message..." />
            </div>
            <div>
              <button class="sand" @click="addClick" style="width: 100px;height: 30px;">Send</button>
            </div>
          </div>
        </div>

      </div>

    </div>
  </div>
</template>

<script>
import axios from 'axios'
import  Float  from "../components/Float";
export default {
  components:{
    Float
  },
  data() {
    return {
      input: '',
      textarea: '',
      fullName: '',
      mobile: '',
      email: '',
      message: '',
    }
  },
  // mounted() {
  //   this.addClick()
  // },
  methods: {
    addClick() {
      // axios.post('http://192.168.31.101:31200/customer/contact/add',{}).then(res => {
      axios.post('http://unicorn-uiserver-server.palm-cube.com/customer/contact/add ', {
        fullName: this.fullName, mobile: this.mobile, email: this.email, message: this.message
      }).then(res => {
        this.fullName = '',
          this.mobile = '',
          this.email = '',
          this.message = ''
          if (res.data.errCode==0) {
          this.$router.push('/thanks');

          //   this.$notify({
          //   title: 'success',
          //   type: 'success'
          // });
            
          }
        // this.$message.success('添加成功！')
        console.log(res)
      }).catch(error => {
        console.log(error)
      })
    }
  }
}
</script>

<style lang="scss">
.case {
  display: block;
}

.casePcS {
  padding: 20px 60px;
  margin-top: 100px;
  margin-bottom: 60px;
  display: flex;
  justify-content: space-evenly;
  align-items: center;

  .casePcSl {

    span {
      font-size: 18px;
      font-weight: 600;
      color: #444198;
    }

    p {
      font-size: 8px;
    }

    .join {
      font-size: 8px;
      color: #444198;

    }
  }

  .casePcSr {
    img {
      width: 200px;
    }
  }
}

.casePhone {
  display: none;
  height: 1600px;

}

.casePhoneCases {
  margin-top: 100px;
  height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 50px;
  font-weight: 600;
  color: #444198;
  // display: flex;

}

.casePhoneCasesP {
  text-align: center;

  p {
    font-size: 15px;
  }
  .casePhoneCasesJoin{
    font-size: 15px;
    color: #444198;
  }
}

.casePhoneCasesImg{
  text-align: center;
  margin-top: 50px;
  margin-bottom: 50px;
  img{
    width: 400px;
  }
}
.aboutPhoneUs {
  background-color: #F2F2F2;

  >div:nth-child(1) {
    text-align: left;
    padding: 40px 40px  0px 40px;
    img {
      width: 200px;
      // font-size: 40px;
    }

    .Contact1 {
      font-size: 40px;
      font-weight: 600;
      color: #444198;
    }

    .Contact2 {
      font-size: 40px;
      font-weight: 600;
      // color: #444198;
    }

    p {
      font-size: 20px;

    }
  }
}

.aboutPhoneUsright {
  padding: 0 40px;
  height: 600px;
  // margin-top: 20px;

  >div:nth-child(1) {
    margin: 10px 0;
  }

  >div:nth-child(2) {
    margin: 10px 0;
  }

  >div:nth-child(3) {
    margin: 10px 0;
  }

  >div:nth-child(4) {
    margin: 10px 0px 0px 0px;
  }

  >div:nth-child(5) {
    // margin: 40px 0;

    .sand {
      text-align: center;
      background-color: #444198;
      color: #fff;
      border-radius: 20px;
      border: none;
    }
  }
}







.aboutD {
  background-color: #F2F2F2;
  width: 100%;
  height: 250px;
  // display: flex;

  .aboutD-z {
    padding: 20px 100px;
    display: flex;
    justify-content: space-evenly;
    // justify-content: center;
    // align-items: center;
  }


  // color:	#F5F5F5;
  .left {
    // width: 60%;
    text-align: left;

    img {
      width: 60px;
    }

    .us {
      display: block;
      color: #444198;
      font-size: 16px;
      font-weight: 600;
    }

    p {
      font-size: 5px;
      color: #000;
    }

    span {
      font-size: 18px;
      font-weight: 600;

    }

    .lagos {
      font-size: 18px;
      font-weight: 600;
    }
  }

  .right {

    // margin-top: 20px;

    >div:nth-child(1) {
      margin: 10px 0;
    }

    >div:nth-child(2) {
      margin: 10px 0;
    }

    >div:nth-child(3) {
      margin: 10px 0;
    }

    >div:nth-child(5) {
      margin: 5px 0;

      .sand {
        text-align: center;
        background-color: #444198;
        color: #fff;
        border-radius: 20px;
        border: none;
      }
    }
  }
}



@media(max-width: 1200px) {

  .case {
    display: none;
  }

}

@media(max-width: 1200px) {

  .casePhone {
    display: block;
  }

}</style>